export const state = () => ({
    jobViewCount: 0,
    showBottomDialogue: true,
});
